import { LazyImport, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "FloodgateFeedback", webpackPrefetch: true */ './lazyIndex')
);

export const lazyLogFloodgateActivity = new LazyImport(lazyModule, m => m.logFloodgateActivity);

import { SearchScenarioId } from 'owa-search';
export { SearchScenarioId };
export { SurveyActivityType } from './utils/surveySettingsAndConstants';
